export default class Money {
  amount!: number;
  currencyCode!: string;

  constructor(response?: any) {
    this.amount = (response && response.amount) || 0;
    this.currencyCode = (response && response.currencyCode) || "";
  }
}
